<template>
  <vs-popup :title="$t('ImagePreview')" :active.sync="showModal">
    <div>
      <img
        :src="URLS_CONSTANTS.assets + 'baskets/' + model"
        class="block mx-auto w-full my-0 text-center"
      />
    </div>
  </vs-popup>
</template>

<script>
import { URLS_CONSTANTS } from "../../../../config";
export default {
  name: "basketManagement_ChannelBaskets_imagePopup",
  props: {
    show: { default: false },
    model: {
      default: {}
    }
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish");
      }
    }
  },
  data() {
    return {
      URLS_CONSTANTS: URLS_CONSTANTS
    };
  }
};
</script>
